import { render, staticRenderFns } from "./JobComponent.vue?vue&type=template&id=a704e1ca&scoped=true"
import script from "./JobComponent.vue?vue&type=script&lang=ts"
export * from "./JobComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a704e1ca",
  null
  
)

export default component.exports